<script lang="ts" setup>
import { computed } from "vue";
import { useAuthStore, type Permission } from "@/stores/auth";

interface Props {
  permissions?: Permission[];
}
const props = defineProps<Props>();

const auth = useAuthStore();
const allowed = computed(() => {
  if (!props.permissions) return true;
  return props.permissions.some((permission) => {
    return auth.permissions.includes(permission);
  });
});
</script>

<template>
  <slot v-if="allowed"></slot>
  <slot v-else-if="$slots.fallback" name="fallback"></slot>
</template>
